import { all } from 'redux-saga/effects';

import { statsConfigSagas } from './ducks/config';
import { gameShiftsSagas } from './ducks/gameShifts';
import { glossarySagas } from './ducks/glossary';
import { leadersSagas } from './ducks/leaders';
import { milestonesSagas } from './ducks/milestones';
import { playersAndTeamsSagas } from './ducks/playersAndTeams';
import { puckAndPlayerTrackingSagas } from './ducks/puckAndPlayerTracking';

export default function* rootSaga() {
    yield all([
        statsConfigSagas(),
        gameShiftsSagas(),
        glossarySagas(),
        leadersSagas(),
        milestonesSagas(),
        playersAndTeamsSagas(),
        puckAndPlayerTrackingSagas(),
    ]);
}
